import { ImageX } from 'blaze-ui/icons/20/ImageX'
import Styles from './AddMedia.module.scss'
import cx from 'classnames'
import { ImageAdd } from 'blaze-ui/icons'

interface Props {
  hasReplaceableImage: boolean
  onPress: () => void
}

export const AddMedia = ({ hasReplaceableImage, onPress }: Props) => {
  if (!hasReplaceableImage) {
    return (
      <div className={cx(Styles.addMediaButton, Styles.disabled)}>
        <ImageX color="var(--dark-40)" />
        <div className={cx(Styles.label, Styles.disabled)}>No Media Needed</div>
      </div>
    )
  }

  return (
    <button className={Styles.addMediaButton} onClick={onPress}>
      <ImageAdd />
      <div className={Styles.label}>Add Media</div>
    </button>
  )
}
